// Sport Workspaces v1.0 — the hero sport switcher. A premium segmented control
// in the Topbar; one pill per live sport workspace. Clicking a sport jumps to
// its dashboard (its own decluttered sidebar follows from the active sport).
// Only live sports appear — planned sports are hidden until they go live.
import { useActiveSport } from "../../sports/useActiveSport.ts";
import { Icon } from "../icons/Icon.tsx";

export function SportSwitcher(): JSX.Element {
  const { active, sports, switchTo } = useActiveSport();
  return (
    <div className="sport-switcher" role="tablist" aria-label="Sport">
      {sports.map((s) => {
        const isActive = s.key === active.key;
        return (
          <button
            key={s.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`sport-pill${isActive ? " active" : ""}`}
            onClick={() => switchTo(s.key)}
            title={`${s.name} workspace`}
          >
            <Icon name={s.icon} size={15} />
            <span>{s.name}</span>
          </button>
        );
      })}
    </div>
  );
}
